// src/App.js
import React, { useEffect } from 'react';
import { LanguageProvider } from './LanguageContext.js';
import Header from './components/Header.js';
import Hero from './components/Hero.js';
import About from './components/About.js';
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';

const initAOS = () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('aos-animate');
      }
    });
  }, observerOptions);

  document.querySelectorAll('[data-aos]').forEach(element => {
    element.classList.add('aos-init');
    observer.observe(element);
  });
};

const App = () => {
  useEffect(() => {
    // Set smooth scrolling
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Initialize animation on scroll
    initAOS();
    
    // Cleanup
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white font-sans text-primary">
        <Header />
        <Hero />
        <About />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default App;